export default __webpack_public_path__ + "static/media/K_wdt_c_cap_2.8538d16e.mp3";